// extracted by mini-css-extract-plugin
module.exports = {"toggle":"styles_toggle__2O1Pb","uploadTitle":"styles_uploadTitle__3JOGZ","divContent":"styles_divContent__3hADy"};